<template>
  <div
    class="layoutFooter"
  >
    Copyright&nbsp;©&nbsp;2023-2033&nbsp;&nbsp;jinli.&nbsp;&nbsp;All Rights Reserved 粤ICP备2024209091号-1
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.layoutFooter{
    padding:20px 0;
    background-color: #10284c;
    // vertical-align: middle;
    text-align: center;
    font-size: 14px;
    color: #F9FBFC;
  }
</style>
